import Network from "../network/network";
import SessionCache from "../network/SessionCache";

export default class MeService {
    private ODATA_ROUTE = "Me";

    private readonly network: Network;

    constructor(network: Network) {
        this.network = network;
    }

    public switchCompany = async (companyId: number): Promise<void> => {
        await this.network.sendPublicApi(`${this.ODATA_ROUTE}/switchcompany`, companyId);
        // Rights are granted per company, and the account names the company it is in.
        SessionCache.forget();
    };
}
